var lists_default = {
  "fontElementMap": "WYYFn",
  "orderedlist": "FQg3t",
  "bulletedlist": "Lmkda",
  "listItem": "Y-FNo"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
